// import parseTime, formatTime and set to filter
// import dayjs from "dayjs";
export { parseTime, formatTime } from '@/utils'

/**
 * Show plural label if time is plural number
 * @param {number} time
 * @param {string} label
 * @return {string}
 */
function pluralize(time, label) {
  if (time === 1) {
    return time + label
  }
  return time + label + 's'
}

/**
 * @param {number} time
 */
export function timeAgo(time) {
  const between = Date.now() / 1000 - Number(time)
  if (between < 3600) {
    return pluralize(~~(between / 60), ' minute')
  } else if (between < 86400) {
    return pluralize(~~(between / 3600), ' hour')
  } else {
    return pluralize(~~(between / 86400), ' day')
  }
}

/**
 * Number formatting
 * like 10000 => 10k
 * @param {number} num
 * @param {number} digits
 */
export function numberFormatter(num, digits) {
  const si = [
    { value: 1E18, symbol: 'E' },
    { value: 1E15, symbol: 'P' },
    { value: 1E12, symbol: 'T' },
    { value: 1E9, symbol: 'G' },
    { value: 1E6, symbol: 'M' },
    { value: 1E3, symbol: 'k' }
  ]
  for (let i = 0; i < si.length; i++) {
    if (num >= si[i].value) {
      return (num / si[i].value).toFixed(digits).replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1') + si[i].symbol
    }
  }
  return num.toString()
}

/**
 * 10000 => "10,000"
 * @param {number} num
 */
export function toThousandFilter(num) {
  return (+num || 0).toString().replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
}

/**
 * Upper case first char
 * @param {String} string
 */
export function uppercaseFirst(string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

/**
 * @param {String} string
 */
 export function phoneSpace(string) {
	return string.replace(/(\d{3})(\d{4})/, "$1 $2 ");
  }


// ! 格式化时间
export function formatDate(date, format = 'YYYY/MM/DD HH:mm:ss') {
    if (!date) {
        return '---';
    }
    return dayjs(date).format(format);
}

// ! 格式化时间 - 
export function formatTimeMessage(valueTime) {
	if (valueTime) {
		// let newData = Date.parse(new Date() + '')
		// let diffTime = Math.abs(newData - valueTime)
		let diffTime = Math.abs(new Date().getTime() - new Date(valueTime).getTime())
		if (diffTime > 7 * 24 * 3600 * 1000) {
		let date = new Date(valueTime)
		// let y = date.getFullYear()
		let m = date.getMonth() + 1
		m = m < 10 ? ('0' + m) : m
		let d = date.getDate()
		d = d < 10 ? ('0' + d) : d
		let h = date.getHours()
		h = h < 10 ? ('0' + h) : h
		let minute = date.getMinutes()
		let second = date.getSeconds()
		minute = minute < 10 ? ('1' + minute) : minute
		second = second < 10 ? ('0' + second) : second
		return m + '-' + d + ' ' + h + ':' + minute
		} else if (diffTime < 7 * 24 * 3600 * 1000 && diffTime > 24 * 3600 * 1000) {
		// //注释("一周之内");
		// var time = newData - diffTime;
		let dayNum = Math.floor(diffTime / (24 * 60 * 60 * 1000))
		return dayNum + '天前'
		} else if (diffTime < 24 * 3600 * 1000 && diffTime > 3600 * 1000) {
		// //注释("一天之内");
		// var time = newData - diffTime;
		let dayNum = Math.floor(diffTime / (60 * 60 * 1000))
		return dayNum + '小时前'
		} else if (diffTime < 3600 * 1000 && diffTime > 0) {
		// //注释("一小时之内");
		// var time = newData - diffTime;
		let dayNum = Math.floor(diffTime / (60 * 1000))
		return dayNum + '分钟前'
		}
	}
}